import React from 'react';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { fmtN } from './JoBits';
import { PoTag, srcText } from './JoSources';

const KIND = { bundle: 'Bundle', box: 'Box', pieces: 'Pieces in' };

const Item = ({ g, done }) => (
  <li className="rounded-md border border-[#E5DFD0] bg-white px-3 py-2" data-testid={`jo-stage-item-${g.code}`}>
    <div className="flex items-center justify-between gap-2">
      <span className="text-sm"><span className="text-gray-500">{KIND[g.kind] || ''}</span> <span className="font-mono font-medium">{g.code}</span></span>
      <span className="text-sm font-semibold tabular-nums">{fmtN(g.pcs)} pcs</span>
    </div>
    <div className="mt-0.5 flex flex-wrap items-center gap-x-2 text-[11px] text-gray-500">
      {!done && <span className={g.days > 3 ? 'font-semibold text-amber-700' : ''}>{g.days} day(s) here</span>}
      {done && <span className="text-emerald-700">Received in SFG Storage</span>}
      {g.root && g.root !== g.code && <span>from <span className="font-mono">{g.root}</span></span>}
      {g.source && <span>{srcText(g.source)}</span>}
      {g.source && <PoTag po={g.source.po_number} testId={`jo-stage-item-po-${g.code}`} />}
    </div>
  </li>
);

/** Side panel: the bundles / boxes of one stage, oldest first, each with its source. */
export const JoStageSheet = ({ stage, onClose }) => (
  <Sheet open={!!stage} onOpenChange={(v) => !v && onClose()}>
    <SheetContent className="w-full sm:max-w-md overflow-y-auto bg-[#FFFBF5]" data-testid="jo-stage-sheet">
      {stage && (
        <>
          <SheetHeader><SheetTitle data-testid="jo-stage-sheet-title">{stage.label}</SheetTitle>
            <SheetDescription>{fmtN(stage.done_pcs)} pcs passed · {fmtN(stage.waiting_pcs)} pcs waiting{stage.lost_pcs ? ` · ${fmtN(stage.lost_pcs)} rejected` : ''}</SheetDescription></SheetHeader>
          <ul className="mt-4 space-y-2">
            {!(stage.items || []).length && !(stage.done_items || []).length && <li className="text-sm text-gray-500" data-testid="jo-stage-sheet-empty">Nothing waiting at this stage</li>}
            {(stage.items || []).map((g) => <Item key={`w-${g.code}`} g={g} />)}
            {(stage.done_items || []).map((g) => <Item key={`d-${g.code}`} g={g} done />)}
          </ul>
        </>
      )}
    </SheetContent>
  </Sheet>
);
